import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import MerchantLayout from '../../layout/MerchantLayout';
import { getMerchantDataPasses, getMerchantOffers } from '../../services/c2dcrm';
import { MerchantOfferEdit } from '../../types/offer';
import { useAuth } from '../../hooks/useAuth';
import MerchantOfferCard from '../../components/Cards/MerchantOfferCard';
import Link from '@material-ui/core/Link';
import { DataPass } from '../../types/dataPassport';

const useStyles = makeStyles(() => ({
  container: {
    display: 'grid',
    placeItems: 'center',
  },
  grid: {
    maxWidth: '764px',
  },
  banner: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    margin: '16px',
  },
  perks: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

type OfferStateType = {
  offers: MerchantOfferEdit[];
  loading: boolean;
};

type PassStateType = {
  passes: DataPass[];
  loading: boolean;
};

const MerchantPerksListingPage: React.FC = () => {
  const classes = useStyles();
  const [offers, setOffers] = useState<OfferStateType>({ offers: [], loading: false });
  const [dataPassports, setDataPassports] = useState<PassStateType>({ passes: [], loading: false });
  const { token } = useAuth();

  const fetchOffers = async () => {
    setOffers({ offers: [], loading: true });
    getMerchantOffers(token).then((response) => { 
      setOffers({ offers: response.data, loading: false });
    })
  };

  const fetchPasses = async () => {
    setDataPassports({ passes: [], loading: true });
    getMerchantDataPasses(token).then((response) => {
      setDataPassports({ passes: response.data, loading: false });
    })
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  useEffect(() => {
    fetchPasses();
  }, []);

  if (offers.loading) {
    return (
      <MerchantLayout>
        <Typography className={classes.banner} variant="subtitle1">
          <CircularProgress />
        </Typography>
      </MerchantLayout>
    );
  }

  if (!offers.loading && offers.offers.length === 0) {
    return (
      <MerchantLayout>
        <Typography className={classes.banner} variant="subtitle1">
          <Link href="/merchant/offers/create">Add an Offer</Link>
        </Typography>
      </MerchantLayout>
    );
  }

  return (
    <MerchantLayout>
      <div className={classes.container}>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          spacing={4}
          className={classes.grid}
        >
          <>
            <Grid item className={classes.banner}>
              <Typography variant="h1" color="primary">
                These are your existing offers.
              </Typography>
            </Grid>
            {!offers.loading && offers.offers.map((offer) => (
              <Grid item key={offer.id}>
                <MerchantOfferCard passes={dataPassports.passes} offer={offer} />
              </Grid>
            ))}
          </>
        </Grid>
      </div>
    </MerchantLayout>
  );
};

export default MerchantPerksListingPage;
